const LOCALE_DEFAULT = 'en-US';
const LOCALE_SUPPORTED = [LOCALE_DEFAULT, 'en-MX', 'es-MX'];
const I18N_API_HEADERS = { 'IM-SenderID': 'IMGDE' };

exports.LOCALE_DEFAULT = LOCALE_DEFAULT;
exports.LOCALE_SUPPORTED = LOCALE_SUPPORTED;
exports.I18N_API_HEADERS = I18N_API_HEADERS;
